<!--
 * @Description  : 场地门禁记录 - 进场记录
 * @Author       : zcc
 * @Date         : 2025-04-09 10:01:48
 * @LastEditors  : zcc
 * @LastEditTime : 2025-04-09 17:46:10
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\site-entrance-records\components\entry-log-dialog.vue
-->
<template>
  <div class="h100">
    <el-table
      ref="xTable"
      :data="entryLogData"
      highlight-current-row
      align="left"
      height="100%"
      border
    >
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="operate" label="操作ID"></el-table-column>
      <el-table-column prop="enteyTime" label="进入时间"></el-table-column>
      <el-table-column prop="accessCode" label="门禁码"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getEntryLog } from "api/modules/fieldManagement";
export default {
  props: {
    entryLog: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      name: "entryLogDialog",
      entryLogData: [] //进场日志数据
    };
  },
  watch: {
    entryLog: {
      handler: function(newVal) {
        this.parentParams = newVal;
        if (this.parentParams.type != "add") {
          // this.getEntryLog(); // 查看进场日志
        }
      },
      deep: true, // 确认是否深入监听。（一般监听时是不能监听到对象属性值的变化的，数组的值变化可以听到。）
      immediate: true // 确认是否以当前的初始值执行handler的函数。
    }
  },
  mounted() {
    this.getEntryLog(); // 获取进场日志
  },
  methods: {
    // 获取进场日志
    getEntryLog() {
      this.entryLogData = []; // 清空 进场日志列表
      getEntryLog({}).then(res => {
        if (res.code == 0) {
          this.entryLogData = res.data; // 赋值 进场日志列表
        }
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
